import { generatePath } from 'react-router';
import { useAssessmentsOverviewContext } from '../Contexts/AssessmentsOverviewContext';
import ActiveAssessmentsOverviewList from './ActiveAssessmentsOverviewList';
import ClosedAssessmentsOverviewList from './ClosedAssessmentsOverviewList';
import useClientIdPathParam from '@/Hooks/UseClientIdPathParam';
import useCompanyId from '@/Hooks/UseCompanyId';
import RoutePath from '@/Routing/RoutePath';

function AssessmentsOverviewTabs() {
    const { currentTab } = useAssessmentsOverviewContext();
    const companyId = useCompanyId();
    const clientId = useClientIdPathParam();

    const open = generatePath(RoutePath.AssessmentsActive, { companyId, clientId });
    const closed = generatePath(RoutePath.AssessmentsClosed, { companyId, clientId });

    return (
        <>
            {currentTab === open && <ActiveAssessmentsOverviewList />}
            {currentTab === closed && <ClosedAssessmentsOverviewList />}
        </>
    );
}

export default AssessmentsOverviewTabs;
